module.exports = __webpack_public_path__ + "img/puzzle_24.2344d1f8.png";